import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router';

const RouteValidator = ({ children, routeProps }) => (routeProps?.location?.isValidRedirection ? children : <Redirect to={{ pathname: '/' }} />);

export default RouteValidator;

RouteValidator.defaultProps = {
    children: <></>,
    routeProps: {
        location: {
            isValidRedirection: false
        }
    }
};

RouteValidator.propTypes = {
    children: PropTypes.node,
    routeProps: PropTypes.shape()
};
